// Shape-only email check, mirroring the server's lib/util/email_shape.js: one @, a non-empty
// local part, a dotted domain, no whitespace. Keep the two in sync — the server rejects these
// fields with a 400, and a client that allows more just turns a preventable mistake into a
// confusing server error.
//
// Why this exists at all: parent_email / parent_email_2 are free-text columns, and admins have
// typed notes into them on prod. Those values go straight into the To: header of the automated
// parent emails (prep due-reminders, progress reports), where one malformed entry fails the
// entire message — silently muting the other parent too.
export const looksLikeEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? "").trim());

// Returns an admin-facing message for the first malformed field, or null when all are fine.
// Blank/absent values pass: these fields are optional, and clearing one is a legitimate edit.
// `labels` maps a field name to what the form calls it, so the alert matches the visible label.
export function firstInvalidEmail(values = {}, labels = {}) {
    for (const field of Object.keys(labels)) {
        const raw = values[field];
        if (raw === undefined || raw === null) continue;
        const value = `${raw}`.trim();
        if (value === "") continue;
        if (!looksLikeEmail(value)) {
            return `${labels[field]} must be a valid email address. "${value}" isn't one — notes belong in the student's memo.`;
        }
    }
    return null;
}

export const PARENT_EMAIL_LABELS = {
    parent_email: "Parent's Email",
    parent_email_2: "Parent's Email 2",
};
